"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionInteractionInputSchema = exports.sessionInteractionInputBaseSchema = exports.sessionInteractionSchema = exports.sessionNeedsReplySchema = void 0;
const zod_1 = require("zod");
const base_1 = require("./interactions/base");
const audioChunk_1 = require("./interactions/inputs/audioChunk");
const alert_1 = require("./interactions/kinds/alert");
const answer_1 = require("./interactions/kinds/answer");
const audio_1 = require("./interactions/kinds/audio");
const audioBuffer_1 = require("./interactions/kinds/audioBuffer");
const audioBufferText_1 = require("./interactions/kinds/audioBufferText");
const audioChunk_2 = require("./interactions/kinds/audioChunk");
const audioText_1 = require("./interactions/kinds/audioText");
const button_1 = require("./interactions/kinds/button");
const carousel_1 = require("./interactions/kinds/carousel");
const contact_1 = require("./interactions/kinds/contact");
const delay_1 = require("./interactions/kinds/delay");
const document_1 = require("./interactions/kinds/document");
const drawer_1 = require("./interactions/kinds/drawer");
const image_1 = require("./interactions/kinds/image");
const redirect_1 = require("./interactions/kinds/redirect");
const select_1 = require("./interactions/kinds/select");
const sticker_1 = require("./interactions/kinds/sticker");
const tag_1 = require("./interactions/kinds/tag");
const text_1 = require("./interactions/kinds/text");
const textDelta_1 = require("./interactions/kinds/textDelta");
const video_1 = require("./interactions/kinds/video");
exports.sessionNeedsReplySchema = zod_1.z.union([
    zod_1.z.object({ needsReply: zod_1.z.literal(false) }),
    zod_1.z.object({
        needsReply: zod_1.z.literal(true),
        replyTypes: zod_1.z.array(base_1.sessionInteractionReplyTypeSchema),
        // todo: mask should exist only if replyTypes includes text
        mask: zod_1.z.enum(["phone", "email", "otpCode"]).nullish(),
        // todo: suggestions should exist only if replyTypes includes text
        suggestions: zod_1.z.array(zod_1.z.string()).optional(),
        // todo: suggestionsTitle should exist only if suggestions exists
        suggestionsTitle: zod_1.z.string().optional(),
    }),
]);
exports.sessionInteractionSchema = zod_1.z
    .union([
    // Schemas with Assessment
    text_1.botTextSchema,
    textDelta_1.textDeltaSchema,
    text_1.userTextSchema,
    video_1.userVideoSchema,
    video_1.botVideoSchema,
    audioText_1.userAudioTextSchema,
    audioText_1.botAudioTextSchema,
    answer_1.userAnswerSchema,
    select_1.userSelectSchema,
    select_1.botSelectSchema,
    image_1.userImageSchema,
    image_1.botImageSchema,
    drawer_1.drawerSchema,
    alert_1.alertSchema,
    // Schemas wihout assessment
    // NOTE: all audio schemas below don't have an assessment because
    // they are converted to audio: text before get assessed
    // Also, some one them are intermediate and are not ready (example: audioChunkSchema)
    audio_1.audioSchema,
    audioBuffer_1.audioBufferSchema,
    audioBufferText_1.audioBufferTextSchema,
    audioChunk_2.audioChunkSchema,
    delay_1.delaySchema,
    tag_1.tagSchema,
    button_1.buttonSchema,
    redirect_1.redirectSchema,
    sticker_1.stickerSchema,
    document_1.documentSchema,
    contact_1.contactSchema,
    carousel_1.carouselSchema,
])
    .and(base_1.sessionInteractionBaseSchema)
    .and(exports.sessionNeedsReplySchema);
const sessionBaseSchema = zod_1.z.discriminatedUnion("sessionKind", [
    zod_1.z.object({ sessionKind: zod_1.z.literal("conversation") }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("be-teacher"), action: zod_1.z.string() }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("activity") }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("stateless") }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("bot") }),
    zod_1.z.object({
        sessionKind: zod_1.z.literal("onboarding:product-discovery"),
    }),
    zod_1.z.object({
        sessionKind: zod_1.z.literal("onboarding:user-data-collection"),
    }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("onboarding:social-proof") }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("placement-test") }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("onboarding:post-purchase") }),
    zod_1.z.object({ sessionKind: zod_1.z.literal("sales-rep") }),
]);
/**
 * SessionInteractionInputBaseSchema contains every necessary to start a new chat and keep
 * a sessions every it was started, simply listen to app:session:${sessionId}
 */
exports.sessionInteractionInputBaseSchema = zod_1.z
    .object({
    sessionId: zod_1.z.string(),
    jwt: zod_1.z.string(),
    voiceId: zod_1.z.string().nullish(),
})
    .and(sessionBaseSchema);
exports.sessionInteractionInputSchema = zod_1.z
    .discriminatedUnion("kind", [
    audio_1.audioBaseSchema,
    image_1.imageBaseSchema,
    audioBuffer_1.audioBufferSchema,
    audioBufferText_1.audioBufferTextSchema,
    audioChunk_1.audioChunkInputSchema,
    audioText_1.audioTextBaseSchema,
    text_1.textBaseSchema,
])
    .and(sessionBaseSchema)
    .and(zod_1.z.object({
    _id: zod_1.z.string(),
    sessionId: zod_1.z.string(),
    jwt: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    replyInteractionId: zod_1.z.string().nullish(),
}));
//# sourceMappingURL=session.js.map